"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ProgressSection = _interopRequireWildcard(require("./ProgressSection"));
var _ProgressBarModule = _interopRequireDefault(require("./ProgressBar.module.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ProgressBar = _ref => {
  let {
    activeSection,
    progressText,
    onSectionClick,
    progressStatus
  } = _ref;
  const computeProgressStatus = (progressNumber, activeSection) => {
    if (progressNumber < Number(activeSection)) {
      return _ProgressSection.ProgressStatusList.COMPLETED;
    }
    if (progressNumber === Number(activeSection)) {
      return _ProgressSection.ProgressStatusList.ACTIVE;
    }
    if (progressNumber > Number(activeSection)) {
      return _ProgressSection.ProgressStatusList.IDLE;
    }
  };
  const handleProgressBarStatus = (progressNumber, activeSection) => {
    if (progressNumber === Number(activeSection) && progressStatus?.[progressNumber] === _ProgressSection.ProgressStatusList.IDLE) {
      return _ProgressSection.ProgressStatusList.ACTIVE;
    }
    if (progressStatus?.[progressNumber]) {
      return progressStatus[progressNumber].toLowerCase();
    }
    return computeProgressStatus(progressNumber, activeSection);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _ProgressBarModule.default.tabsContainer
  }, /*#__PURE__*/_react.default.createElement("ul", null, progressText.map((text, index) => /*#__PURE__*/_react.default.createElement(_ProgressSection.default, {
    progressNumber: index + 1,
    progressText: text,
    progressStatus: handleProgressBarStatus(index + 1, activeSection),
    key: text,
    onSectionClick: onSectionClick
  }))));
};
ProgressBar.propTypes = {
  activeSection: _propTypes.default.number,
  progressText: _propTypes.default.arrayOf(_propTypes.default.string),
  onSectionClick: _propTypes.default.func,
  progressStatus: _propTypes.default.object
};
ProgressBar.defaultProps = {
  progressStatus: {}
};
var _default = exports.default = ProgressBar;